import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/vendor.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyScriptsManager"] */ "/app/components/ThirdPartyScriptsManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentPreviewBadge"] */ "/app/features/shared/ContentPreviewBadge.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
